// Filter.tsx
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface FilterProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (filters: {
    requestedFromDate?: string;
    requestedToDate?: string;
    answeredFromDate?: string;
    answeredToDate?: string;
  }) => void;
  onClear: () => void;
}

const Filter: React.FC<FilterProps> = ({
  isOpen,
  onClose,
  onApply,
  onClear,
}) => {
  const [requestedFromDate, setRequestedFromDate] = useState<Date | null>(null);
  const [requestedToDate, setRequestedToDate] = useState<Date | null>(null);
  const [answeredFromDate, setAnsweredFromDate] = useState<Date | null>(null);
  const [answeredToDate, setAnsweredToDate] = useState<Date | null>(null);

  const formatLocalDate = (date: Date | null) => {
    if (!date) return undefined;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // const handleApply = () => {
  //   onApply({
  //     requestedFromDate: requestedFromDate ? requestedFromDate.toISOString().split('T')[0] : undefined,
  //     requestedToDate: requestedToDate ? requestedToDate.toISOString().split('T')[0] : undefined,
  //     answeredFromDate: answeredFromDate ? answeredFromDate.toISOString().split('T')[0] : undefined,
  //     answeredToDate: answeredToDate ? answeredToDate.toISOString().split('T')[0] : undefined,
  //   });
  //   onClose();
  // };

  const handleApply = () => {
    onApply({
      requestedFromDate: formatLocalDate(requestedFromDate),
      requestedToDate: formatLocalDate(requestedToDate),
      answeredFromDate: formatLocalDate(answeredFromDate),
      answeredToDate: formatLocalDate(answeredToDate),
    });
    onClose();
  };

  const handleClear = () => {
    setRequestedFromDate(null);
    setRequestedToDate(null);
    setAnsweredFromDate(null);
    setAnsweredToDate(null);
    onClear();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="absolute right-0 z-10 bg-white rounded-lg shadow w-96 mt-2">
      <div className="flex items-center justify-between p-3 border-b border-lightgray-100">
        <h3 className="text-base font-semibold text-grease-100">Filters</h3>
        <button onClick={onClose}>
          <svg className="w-3 h-3" viewBox="0 0 14 14">
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
        </button>
      </div>
      <div className="bg-indigo-200 bg-opacity-25 rounded-lg mt-4 p-4 mx-3 mb-4">
        <p className="text-sm">Requested Date</p>
        <div className="flex sm:flex-nowrap flex-wrap items-center gap-4 mt-3">
          <DatePicker
            selected={requestedFromDate}
            onChange={(date: Date | null) => setRequestedFromDate(date)} // Updated to accept Date | null
            selectsStart
            startDate={requestedFromDate}
            endDate={requestedToDate}
            placeholderText="From Date"
            className="p-3 rounded-lg bg-white text-xs w-full"
            dateFormat="yyyy-MM-dd"
          />
          <DatePicker
            selected={requestedToDate}
            onChange={(date: Date | null) => setRequestedToDate(date)} // Updated to accept Date | null
            selectsEnd
            startDate={requestedFromDate}
            endDate={requestedToDate}
            placeholderText="To Date"
            className="p-3 rounded-lg bg-white text-xs w-full"
            dateFormat="yyyy-MM-dd"
          />
        </div>
      </div>
      <div className="bg-indigo-200 bg-opacity-25 rounded-lg mt-4 p-4 mx-3 mb-4">
        <p className="text-sm">Answered Date</p>
        <div className="flex sm:flex-nowrap flex-wrap items-center gap-4 mt-3">
          <DatePicker
            selected={answeredFromDate}
            onChange={(date: Date | null) => setAnsweredFromDate(date)} // Updated to accept Date | null
            selectsStart
            startDate={answeredFromDate}
            endDate={answeredToDate}
            placeholderText="From Date"
            className="p-3 rounded-lg bg-white text-xs w-full"
            dateFormat="yyyy-MM-dd"
          />
          <DatePicker
            selected={answeredToDate}
            onChange={(date: Date | null) => setAnsweredToDate(date)} // Updated to accept Date | null
            selectsEnd
            startDate={answeredFromDate}
            endDate={answeredToDate}
            placeholderText="To Date"
            className="p-3 rounded-lg bg-white text-xs w-full"
            dateFormat="yyyy-MM-dd"
          />
        </div>
      </div>
      <div className="flex justify-between p-3">
        <button
          className="px-3 py-2 bg-blue-500 bg-opacity-25 rounded-md"
          onClick={onClose}
        >
          Cancel
        </button>
        <div className="flex gap-4">
          <button
            className="px-3 py-2 border border-[#FFD700] rounded-md"
            onClick={handleClear}
          >
            Clear All
          </button>
          <button
            className="px-3 py-2 bg-[#FFD700] rounded-md text-white"
            onClick={handleApply}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default Filter;
